/* eslint max-params: ["error", 5] */

import './rga-tab.scss';
import React, {Component} from 'react';
import ConsignmentDetails from './recalled-part-tab/components/consignment-details';
import DealerDetails from './recalled-part-tab/components/dealer-details';
import PropTypes from 'prop-types';
import RgaConsignmentDetails from '../../../rga-search-results/state/rga-consignment-details';
import RgaDealerDetails from '../../../rga-search-results/state/rga-dealer-details';
import RgaDetails from '../../../rga-search-results/state/rga-details';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import TabNavigation from '../../../../shared/components/tab-navigation';
import {getNavigationTabs} from '../../../shared/advance-returned-part-navigation-helper';

class AdvanceReturnedPartInfoForm extends Component {
    componentWillMount() {

        this.props.actions.setRouteToDefaultTab();

    }
    render() {

        return (
            <section className='rga-tab'>
                <div className='rga-analysis-tabs'>
                    <div className='rga-search-tabs'>
                        <TabNavigation
                            tabs={getNavigationTabs()}
                        />
                    </div>
                </div>
                {this.props.queryParams && this.props.queryParams.tab === 'dealerInfo' &&
                <DealerDetails
                    actions={this.props.actions}
                    busyCounter={this.props.busyCounter}
                    rgaDealerDetails={this.props.rgaDealerDetails}
                    rgaDetails={this.props.rgaDetails}
                    security={this.props.security}
                />
                }
                {this.props.queryParams && this.props.queryParams.tab === 'consignmentInfo' &&
                <ConsignmentDetails
                    actions={this.props.actions}
                    busyCounter={this.props.busyCounter}
                    rgaConsignmentDetails={this.props.rgaConsignmentDetails}
                    rgaDetails={this.props.rgaDetails}
                    security={this.props.security}
                />
                }
            </section>
        );

    }
}

AdvanceReturnedPartInfoForm.displayName = 'AdvanceReturnedPartInfoForm';
AdvanceReturnedPartInfoForm.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    queryParams: PropTypes.object.isRequired,
    rgaConsignmentDetails: PropTypes.instanceOf(RgaConsignmentDetails).isRequired,
    rgaDealerDetails: PropTypes.instanceOf(RgaDealerDetails).isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default AdvanceReturnedPartInfoForm;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/advance-returned-part-information/advance-returned-part-info-form.js